<template>
  <b-form @submit.prevent>
    <b-form-group
      label="Name your quiz"
      label-for="qName"
      description="Make sure the name is something your quizzers can relate to. It will be used to identify your quiz."
    >
      <b-form-input
        id="qName"
        v-model="quiz.name"
        trim
        lazy
        @change="checkValidity"
        autofocus
      />
    </b-form-group>
    <b-form-group
      label="Quiz Date"
      label-for="qDate"
      description="You do not have to set a date for your quiz. If you do however, you can post the quiz in the public calendar."
    >
      <b-form-datepicker
        id="qDate"
        v-model="myDate"
        lazy
        @input="dateTimeChanged"
      />
    </b-form-group>
    <b-form-group
      label="Quiz Time"
      label-for="time"
      description="If you set a date, you must also set a time for the quiz."
    >
      <b-form-input
        id="time"
        v-model="myTime"
        type="time"
        lazy
        @change="dateTimeChanged"
      />
    </b-form-group>
    <b-form-group
      label="Offline venue"
      description="If you are also hosting this quiz offline, set your venue name here. Teams will be able to state whether they are playing offline or not."
    >
      <b-form-input v-model="quiz.venue_name" type="text" lazy />
    </b-form-group>
  </b-form>
</template>

<script>
export default {
  name: "NewQuizPageName",
  props: ["quiz", "validity"],
  model: {
    prop: "validity",
    event: "validity"
  },
  data() {
    return {
      myDate: "",
      myTime: ""
    };
  },
  created() {
    if (this.quiz.event_time > 0) {
      this.myDate = this.$moment(this.quiz.event_time).format("YYYY-MM-DD");
      this.myTime = this.$moment(this.quiz.event_time).format("HH:mm");
    }

    this.checkValidity();
  },
  methods: {
    dateTimeChanged() {
      var time = this.$moment(this.myDate + "T" + this.myTime).valueOf();
      if (!isNaN(time)) {
        this.quiz.event_time = time;
      }

      this.checkValidity();
    },
    checkValidity() {
      var valid = true;
      valid &= this.quiz.name.length > 0;

      if (this.myDate.length > 0 != this.myTime.length > 0) {
        valid = false;
      }

      this.$emit("validity", valid);
    }
  }
};
</script>
